import { HistoryModel } from "../../common/models/global.typing";
import { RecordInfo } from "../../common/models/RecordInfo";
import { PagedRow } from "../../home/models/PageTypes";
import { BankAccountModel } from "../../invoices/models/InvoiceModel";
import { PictureModel, FileType, FileCategory } from "../../pictures/models/PictureModel";

export enum PaymentType {
    all = 0,
    regular = 1,
    writeOff = 2,
    giftCard = 3,
    earningPoint = 4,
}

export interface PaidInvoiceModel {
    paymentId: string;
    invoiceId: string;
    amount: number;
}

export interface PaidInvoiceInfo extends PaidInvoiceModel {
    paymentType: PaymentType;
}

export interface HoldPaymentInputModel {
    id: number;
    amount: number;
    note: string;
    paymentId: string;
    itemId: number;
}
export interface PaymentModelBase extends PagedRow {
    id: string;

    amount: number;
    note?: string;

    customerId: number;
    active: boolean;
    type: PaymentType;

    transactionNo?: string;
    referenceNo?: string;
    fromAccountNo?: string;
    fromName?: string;

    transactionDate: Date;
    accountId: number;
}

export interface ShortPaymentModel extends PaymentModelBase {
    customer: string;
    userId?: string;
    isConfirmed: boolean;
    account: BankAccountModel;
    paidAmount: number;
    holdAmount: number;
    referenceNo?: string;
}

export interface PaymentModel extends PaymentModelBase {
    customer: string;
    customerImageUrl?: string;

    userId?: string;
    picture?: PictureModel;

    applied: number;
    hold: number;
    deposit: number;

    isConfirmed: boolean;
    confirmedById?: string;
    confirmedBy?: string;
    confirmedDate?: Date;

    account: BankAccountModel;
    recordInfo: RecordInfo;

    holds: HoldPaymentInputModel[];
    histories: HistoryModel[];
    invoices: PaidInvoiceInfo[];
}

export interface NewPaymentModel extends PaymentModelBase {
    file?: any;
    fileType: FileType;
    fileCatetory: FileCategory;
    invoices: PaidInvoiceModel[];
}

export interface AppliedPaymentModel {
    id: string;
    type: PaymentType;
    amount: number;
    note?: string;
    applied: boolean;
}

export const createAppliedPaymentModel = (): AppliedPaymentModel => ({
    id: "",
    type: PaymentType.regular,
    amount: 0,
    note: "",
    applied: false
});